import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound, Loader2, Trash2 } from "lucide-react";

export default function PortalAccessDialog({ open, employee, onClose, onChanged }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setPassword(""); }, [open]);

  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/employees/${employee.id}/portal-access`, { password });
      toast.success(`Acceso al portal activado para ${employee.email}`);
      onChanged(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const revoke = async () => {
    setBusy(true);
    try {
      await api.delete(`/employees/${employee.id}/portal-access`);
      toast.success("Acceso al portal revocado");
      onChanged(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="portal-access-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><KeyRound className="h-5 w-5 text-accent" /> Portal del trabajador</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          El trabajador entrará con el email de su ficha (<span className="font-mono">{employee.email || "sin email"}</span>) y la contraseña que fijes.
          Solo verá su ficha, certificados y recibos, y podrá firmar la entrega de EPIs pendientes.
        </p>
        <div className="space-y-1.5">
          <Label>{employee.portal_enabled ? "Nueva contraseña" : "Contraseña"}</Label>
          <Input type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres"
            data-testid="portal-password-input" autoComplete="off" />
        </div>
        <DialogFooter className="flex-row flex-wrap gap-2 justify-end">
          {employee.portal_enabled && (
            <Button variant="ghost" className="text-red-600 mr-auto" onClick={revoke} disabled={busy} data-testid="portal-revoke-button">
              <Trash2 className="h-4 w-4 mr-2" /> Revocar acceso
            </Button>
          )}
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={save} disabled={busy || password.length < 6 || !employee.email} data-testid="portal-save-button">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {employee.portal_enabled ? "Cambiar contraseña" : "Activar acceso"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
